import { useEffect, useState } from "react"

type WindowSize = {
    width: number
    height: number
}

const getWindowSize = (): WindowSize => {
    if (typeof window !== "undefined") {
        return { width: window.innerWidth, height: window.innerHeight }
    }
    return { width: 0, height: 0 }
}

/** Хук возвращающий ширину и высоту окна */
export const useWindowSize = (): WindowSize => {
    const [windowSize, setWindowSize] = useState<WindowSize>(getWindowSize)

    useEffect(() => {
        if (typeof window === "undefined") return

        const handleResize = () => {
            setWindowSize(prev => {
                const width = window.innerWidth
                const height = window.innerHeight
                if (prev.width === width && prev.height === height) return prev
                return { width, height }
            })
        }

        window.addEventListener("resize", handleResize)
        window.addEventListener("orientationchange", handleResize)

        return () => {
            window.removeEventListener("resize", handleResize)
            window.removeEventListener("orientationchange", handleResize)
        }
    }, [])

    return windowSize
}
